/* eslint-disable spire/export-styles */
import translate from "@insite/client-framework/Translate";
import GridContainer from "@insite/mobius/GridContainer";
// import GridItem from "@insite/mobius/GridItem"; // Valtech Custom Code
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
// import Link from "@insite/mobius/Link"; // Valtech Custom Code
// import Typography from "@insite/mobius/Typography"; // Valtech Custom Code
import getColor from "@insite/mobius/utilities/getColor";
import * as React from "react";
import { css } from "styled-components";

/* Valtech Custom Code */
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { GridContainerProps } from "@store/MobiusOverrides/GridContainer/GridContainer";
import { TYPOGRAPHY } from "@store/theme/design";
import { actionLinkStyles, contentSpacingStyles, gridGapStyles } from "@store/theme/mixins";
/* Valtech Custom Code */

interface OwnProps {
    heading: string;
    viewAllUrl?: string;
}

export interface CardListHeadingStyles {
    gridContainer?: GridContainerProps;
    titleGridItem?: GridItemProps;
    linkGridItem?: GridItemProps;
    title?: TypographyProps;
    link?: LinkPresentationProps;
}

const styles: CardListHeadingStyles = {
    gridContainer: {
        gap: 0,
        css: css`
            ${gridGapStyles([TYPOGRAPHY.spacing.base], [null])}
            ${contentSpacingStyles(null, TYPOGRAPHY.spacing.base)}
        `,
    },
    titleGridItem: {
        width: 9,
    },
    linkGridItem: {
        width: 3,
        css: css`
            justify-content: flex-end;
            align-items: flex-end;
        `,
    },
    title: {
        variant: "h3",
        as: "h2",
    },
    link: {
        css: css`
            ${actionLinkStyles()}
        `,
    },
};

const CardListHeading: React.FunctionComponent<OwnProps> = ({ heading, viewAllUrl }) => {
    return (
        /* Valtech Custom Code */
        <GridContainer {...styles.gridContainer}>
            <GridItem {...styles.titleGridItem}>
                <Typography {...styles.title}>{heading}</Typography>
            </GridItem>
            <GridItem {...styles.linkGridItem}>
                {viewAllUrl && (
                    <Link href={viewAllUrl} data-test-selector="cardListHeadingViewAllLink" {...styles.link}>
                        {translate("View All")}
                    </Link>
                )}
            </GridItem>
        </GridContainer>
        /* Valtech Custom Code */
    );
};

export default CardListHeading;
